import { FunctionComponent, useEffect, useState } from 'react';
import { performSearch, getRecentSearches, subscribeRecentSearches, removeRecentSearch } from './Helpers/SearchHelper';
import { Heading } from '@lmig/lmds-react-typography';
import { IconButton, IconClose } from '@lmig/lmds-react-icons';
import { Tooltip } from '@lmig/lmds-react-tooltip';
import { useUserData } from 'Foundation/User/UserContext';

const RecentCustomerSearches: FunctionComponent = () => {
  const [searches, setSearches] = useState<string[]>([]);
  const { userData } = useUserData();

  useEffect(() => {
    setSearches(getRecentSearches());
    const unsubscribe = subscribeRecentSearches(setSearches);
    return unsubscribe;
  }, []);

  const handleClick = (search: string) => {
    if (search) {
      performSearch(search, { isAISGUser: Boolean(userData?.isAISGUser), isMockingAgent: Boolean(userData?.isMockingAgent) });
    }
  };

  const handleRemove = (search: string) => {
    removeRecentSearch(search);
  };

  return (
    <>
      {searches.length > 0 ? (
        <div className="recent-customer-searches">
          <Heading type="h6-small">Recent searches</Heading>
          <ul>
            {searches.map((search, idx) => (
              <li key={idx}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(search);
                  }}
                >
                  {search}
                </a>
                <Tooltip content={`Remove`} direction="right" align="end">
                  <IconButton
                    background="transparent"
                    aria-label={`Remove ${search}`}
                    onClick={() => handleRemove(search)}
                  >
                    <IconClose aria-hidden={true} size="16" />
                  </IconButton>
                </Tooltip>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="no-recent-searches"></div>
      )}
    </>
  );
};

export default RecentCustomerSearches;
